import { useContext } from "react";
import _ from "lodash";

import Slider from "src/components/slider";
import Button from "src/components/button";

import { DealRoomActionPlanContext } from "../context";
import { DealRoomRecipient } from "src/types/dealRoom";

import styles from "./styles.module.scss";
import Text from "src/components/text";
const DefaultUserIcon = "/images/default_user_profile_background.png";

const getRecipientIcon = (recipient: DealRoomRecipient) => {
  const isContact = Object.hasOwn(recipient, "contact");
  const selector = isContact ? "contact" : "user";

  return _.get(recipient, `[${selector}].icon.thumbnail`);
};

const getRecipientName = (recipient: DealRoomRecipient) => {
  const isContact = Object.hasOwn(recipient, "contact");
  const selector = isContact ? "contact" : "user";

  return `${recipient?.[selector]?.firstName} ${recipient?.[selector]?.lastName}`;
};

const getRecipientEmail = (recipient: DealRoomRecipient) => {
  const isContact = Object.hasOwn(recipient, "contact");
  const selector = isContact ? "contact" : "user";

  return `${recipient?.[selector]?.email}`;
};

const CompleteActionSlider = ({ show, handleClose, handleFinish }) => {
  const { state } = useContext(DealRoomActionPlanContext);

  const stageId = _.get(state, "completeAction.stageId", "");
  const actionId = _.get(state, "completeAction.actionId", "");
  const completed = _.get(state, "completeAction.completed", "");

  const actions = _.get(state, `actions[${stageId}].items`, []);
  const targetAction = _.find(
    actions,
    (action) => _.get(action, "id") === actionId,
  );

  const loading = _.get(state, "completeAction.loading", false);
  const recipients = _.get(targetAction, "recipients", []);

  const handleConfirmClick = () => {
    handleFinish(stageId, actionId, completed);
  };

  return (
    <Slider.Dialog width="400" show={show} onClose={handleClose}>
      <Slider.Header>
        <div className={styles.headerContainer}>
          <p className={styles.header}>
            mark <Text
                  text={_.get(targetAction, "actionItem", "")}
                  lines={2}
                />
            {`as ${completed ? "complete" : "incomplete"}?`}
          </p>
          <p className={styles.subtext}>
            This will update your progress tracker.
          </p>
        </div>
      </Slider.Header>

      <Slider.Body>
        {_.size(recipients) > 0 && (
          <div className={styles.bodyContainer}>
            <div className={styles.stakeholdersContainer}>
              <p className={styles.headerNote}>
                These stakeholders will receive a notification about this update
              </p>
              {_.map(recipients, (recipient, index) => {
                return (
                  <div
                    className={styles.stakeholderContainer}
                    key={`recipient-${index}`}
                  >
                    <img
                      src={getRecipientIcon(recipient) || DefaultUserIcon}
                      className={styles.icon}
                    />
                    <div className={styles.stakeholderDetail}>
                      <Text
                        className={styles.stakeholderName}
                        text={getRecipientName(recipient)}
                      />
                      <p className={styles.stakeholderEmail}>
                        {getRecipientEmail(recipient)}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </Slider.Body>

      <Slider.Actions>
        <Button
          icon="paperflite-tick"
          text={loading ? "Confirming" : "Confirm"}
          variant={"primary"}
          disabled={loading}
          onClick={handleConfirmClick}
        />
        <Button text="Cancel" variant="secondary" onClick={handleClose} />
      </Slider.Actions>
    </Slider.Dialog>
  );
};

export default CompleteActionSlider;
